"use client";

import dynamic from "next/dynamic";

import type { AgentsCalculatorProps } from "./AgentsCalculator";

const AgentsCalculator = dynamic(() => import("./AgentsCalculator").then(mod => mod.AgentsCalculator), {
  ssr: false,
});

export function AgentsCalculatorWrapper(props: AgentsCalculatorProps) {
  return <AgentsCalculator {...props} />;
}
